import { useMemo } from "react";

import useEnforceGuardrailsGroup from "../config/useEnforceGuardrailsGroup";
import useInsightsGroup from "../config/useInsightsGroup";
import useShipInfraGroup from "../config/useShipInfraGroup";
import useShareCodeConfigGroup from "../config/useShareCodeConfigGroup";
import useIntegrateServicesGroup from "../config/useIntegrateServicesGroup";
import useManageOrganizationGroup from "../config/useManageOrganizationGroup";
import useTryNewFeatures from "../config/useTryNewFeatures";
import useAiChatItem from "../config/useAiChatItem";
import { MainNavigationItem, MainNavigationMenuItem } from "../types";

const useMainNavigationPrimaryItems = (): {
  navigationItems: MainNavigationItem[];
  menuItems: MainNavigationMenuItem[];
  menuItemsMap: Record<string, MainNavigationMenuItem>;
} => {
  const insightsGroup = useInsightsGroup();
  const shipInfraGroup = useShipInfraGroup();
  const shareCodeConfigGroup = useShareCodeConfigGroup();
  const enforceGuardrailsGroup = useEnforceGuardrailsGroup();
  const integrateServicesGroup = useIntegrateServicesGroup();
  const manageOrganizationGroup = useManageOrganizationGroup();
  const tryNewFeaturesGroup = useTryNewFeatures();
  const aiChatItem = useAiChatItem();

  return useMemo(() => {
    const navigationItems = [
      aiChatItem,
      insightsGroup,
      shipInfraGroup,
      shareCodeConfigGroup,
      enforceGuardrailsGroup,
      integrateServicesGroup,
      manageOrganizationGroup,
      tryNewFeaturesGroup,
    ].filter((item) => item !== undefined);

    const menuItems = navigationItems.flatMap((group) => {
      if ("items" in group) {
        return group.items.flatMap((item) => item.items);
      }
      return [group];
    });

    const menuItemsMap = menuItems.reduce<Record<string, MainNavigationMenuItem>>((acc, item) => {
      acc[item.id] = item;
      return acc;
    }, {});

    return { navigationItems, menuItems, menuItemsMap };
  }, [
    aiChatItem,
    insightsGroup,
    shipInfraGroup,
    shareCodeConfigGroup,
    enforceGuardrailsGroup,
    integrateServicesGroup,
    manageOrganizationGroup,
    tryNewFeaturesGroup,
  ]);
};

export default useMainNavigationPrimaryItems;
